<div class="h-dvh md:h-screen flex flex-col">
  <app-municipality-header></app-municipality-header>

  <div class="w-full shrink-0">
    <div class="max-w-6xl mx-auto px-6 pt-4 flex items-center gap-3">
      <button class="text-sm text-gray-600 hover:text-gray-800" (click)="backToHome()">
        &larr; {{ 'appointment.booking.backToHome' | translate }}
      </button>
      <button *ngIf="step === 'intro'" class="ml-auto text-sm text-brand-600 hover:text-brand-700" (click)="resetToInitial()">
        {{ 'appointment.booking.resetToInitial' | translate }}
      </button>
    </div>
  </div>

  <main class="flex-1 overflow-hidden">
    <div class="max-w-6xl mx-auto px-6 pt-4 pb-10 h-full">
      <!-- Calendar step -->
      <h1 *ngIf="step === 'calendar'" class="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2">
        {{ 'appointment.booking.selectDateTime.title' | translate }}
      </h1>
      <p *ngIf="step === 'calendar'" class="text-gray-600 mb-8">{{ 'appointment.booking.selectDateTime.instructions' | translate }}</p>

      <div *ngIf="step === 'calendar' && (current$ | async) as current" class="mb-6 text-sm text-gray-700">
        {{ 'appointment.booking.bookingFor' | translate }}
        <span class="font-medium">{{ current.label || current.fallbackLabel }}</span>
      </div>
      <div *ngIf="step === 'calendar'" class="flex flex-1 flex-col h-full min-h-0" style="max-height: 80%">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 h-full min-h-0">
          <div class="border rounded-xl p-4 bg-white shadow-sm h-full max-h-full overflow-hidden">
            <div class="flex h-full items-center justify-center">
              <p-date-picker
                [minDate]="moment().toDate()"
                [maxDate]="MAX_DATE"
                [disabledDates]="disabledDates"
                size="large"
                [(ngModel)]="searchDate"
                (ngModelChange)="this.onDateChange()"
                (onMonthChange)="onMonthChange($event)"
                class="kiosk-calendar h-full w-full max-w-full"
                [ngClass]="{ 'lock-prev': !canGoPrev, 'lock-next': !canGoNext }"
                [inline]="true"
              >
                <ng-template #date let-date>
                  <div [ngClass]="{ 'available-date': hasAvailableDate(date) }">{{ date.day }}</div>
                </ng-template>
              </p-date-picker>
            </div>
          </div>
          <div class="border rounded-xl p-4 bg-white shadow-sm h-full max-h-full overflow-auto">
            <div class="text-gray-800 font-medium mb-3">{{ formatSearchDate(searchDate) }}</div>
            @if (this.searchAppointments) {
              <div class="space-y-3">
                @for (slot of this.searchAppointments.appointments || []; track slot.from) {
                  <div
                    class="flex items-center justify-between border rounded-lg p-3"
                    [ngClass]="{ 'bg-green-50 border-green-300': getFieldValue('appointment', this.form)?.from === slot.from }"
                  >
                    <div class="text-gray-800">{{ moment(slot.from, 'HH:mm').format('HH:mm') }}</div>
                    <button class="text-brand-600" (click)="this.selectAppointment(slot)">
                      {{
                        (getFieldValue('appointment', this.form)?.from === slot.from
                          ? 'appointment.booking.selected'
                          : 'appointment.booking.select'
                        ) | translate
                      }}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Walk-in kiosk: name step removed, "Prosegui" books directly (see confirmWalkIn). Previous intro step kept below for reference.
      <section *ngIf="step === 'intro'" class="max-w-2xl">
        <h1 class="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">{{ 'appointment.booking.intro.title' | translate }}</h1>
        <p class="text-gray-600 mb-6">{{ 'appointment.booking.intro.subtitle' | translate }}</p>
        <form [formGroup]="introForm" (ngSubmit)="confirmAndBook()" class="space-y-4">
          <div>
            <label class="block text-sm text-gray-700 mb-1">{{ 'appointment.booking.fields.firstName.label' | translate }}</label>
            <input
              type="text"
              formControlName="firstName"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
              [placeholder]="'appointment.booking.fields.firstName.placeholder' | translate"
            />
            <div class="text-xs text-red-600 mt-1" *ngIf="introForm.controls.firstName.touched && introForm.controls.firstName.invalid">
              {{ 'appointment.booking.fields.firstName.required' | translate }}
            </div>
          </div>
          <div>
            <label class="block text-sm text-gray-700 mb-1">{{ 'appointment.booking.fields.lastName.label' | translate }}</label>
            <input
              type="text"
              formControlName="lastName"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-500"
              [placeholder]="'appointment.booking.fields.lastName.placeholder' | translate"
            />
            <div class="text-xs text-red-600 mt-1" *ngIf="introForm.controls.lastName.touched && introForm.controls.lastName.invalid">
              {{ 'appointment.booking.fields.lastName.required' | translate }}
            </div>
          </div>
          <div class="pt-2">
            <button type="submit" [disabled]="introForm.invalid" class="rounded-lg bg-brand-600 text-white px-5 py-2 disabled:opacity-50">
              {{ 'appointment.booking.book' | translate }}
            </button>
          </div>
        </form>
      </section>
      -->
    </div>
  </main>
  <!-- Footer spacer to leave some room at the bottom while clamped to viewport height -->
  <footer class="w-full shrink-0 border-t border-gray-200 bg-white/60 backdrop-blur h-12 md:h-14">
    @if (this.step === 'calendar') {
      <div class="max-w-6xl mx-auto grid grid-cols-2 pt-2">
        <div class="col-span-1"></div>
        <div class="col-span-1 flex justify-end">
          <!-- Walk-in: books directly. Previous: (click)="proceedToIntro()" -->
          <button
            (click)="confirmWalkIn()"
            [disabled]="!getFieldValue('appointment', this.form)"
            class="rounded-lg bg-brand-600 text-white px-5 py-2 disabled:opacity-50"
          >
            {{ 'appointment.booking.intro.continue' | translate }}
          </button>
        </div>
      </div>
    }
    <!-- Walk-in: no intro step any more. Previous footer for the name step:
    @if (this.step === 'intro') {
      <div class="max-w-6xl mx-auto grid grid-cols-2 pt-2">
        <div class="col-span-1">
          <button (click)="backToCalendar()" class="rounded-lg border border-gray-300 text-gray-700 px-5 py-2">
            {{ 'appointment.booking.back' | translate }}
          </button>
        </div>
        <div class="col-span-1"></div>
      </div>
    }
    -->
  </footer>
</div>

<ngx-spinner [fullScreen]="true" [zIndex]="9999" class="my-spinner">
  <style>
    @keyframes indeterminate {
      0% {
        left: -40%;
        width: 40%;
      }
      50% {
        left: 20%;
        width: 60%;
      }
      100% {
        left: 100%;
        width: 40%;
      }
    }

    .loading-bar {
      position: relative;
      overflow: hidden;
    }

    .loading-bar::after {
      content: '';
      position: absolute;
      top: 0;
      left: -40%;
      height: 100%;
      width: 40%;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 9999px;
      animation: indeterminate 2s infinite ease-in-out;
    }
  </style>

  <div class="flex flex-col items-center gap-6 text-center text-white px-6" style="z-index: 99999">
    <!-- Icon with dotted rotating ring -->
    <div class="relative w-28 h-28 md:w-32 md:h-32">
      <svg viewBox="0 0 120 120" class="w-full h-full" fill="none">
        <!-- rotating dotted ring -->
        <circle cx="60" cy="60" r="44" stroke="#2EA0FF" stroke-width="3" stroke-linecap="round" stroke-dasharray="2 10">
          <!--          <animateTransform attributeName="transform" type="rotate" from="0 60 60" to="360 60 60" dur="1.6s" repeatCount="indefinite"/>-->
        </circle>
        <!-- calendar with check -->
        <rect x="35" y="42" width="50" height="44" rx="8" ry="8" stroke="#8BC0FF" stroke-width="4" />
        <line x1="35" y1="52" x2="85" y2="52" stroke="#8BC0FF" stroke-width="4" />
        <line x1="48" y1="36" x2="48" y2="48" stroke="#8BC0FF" stroke-width="4" />
        <line x1="72" y1="36" x2="72" y2="48" stroke="#8BC0FF" stroke-width="4" />
        <!-- check mark -->
        <path d="M50 68 L58 76 L74 60" stroke="#2EA0FF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <!-- Title & subtitle using i18n translate -->
    <div>
      <div class="text-2xl md:text-3xl font-extrabold">
        {{ loaderText | translate }}
      </div>
      <div class="text-white/80 mt-2">
        {{ 'appointment.booking.spinner.subtitle' | translate }}
      </div>
    </div>

    <!-- Progress bar -->
    <div class="w-[480px] max-w-[80vw] h-1.5 bg-white/25 rounded loading-bar"></div>
  </div>
</ngx-spinner>
